import customDecodeUri from '@/utils/customDecodeUri'

export const splitFilename = (fullName, noDot = false) => {
  const readableName = customDecodeUri(fullName)

  const split = readableName.split('.')
  if (split.length === 1) { // no '.'
    return { name: split[0], suffix: '' }
  }

  const multipartSuffixes = ['tar.gz', 'tar.bz2', 'tar.xz']
  for (let i = multipartSuffixes.length - 1; i >= 0; i--) {
    const multiSuffix = multipartSuffixes[i]
    if (readableName.endsWith(`.${multiSuffix}`)) {
      const name = readableName.slice(0, -(`.${multiSuffix}`.length))
      return { name, suffix: noDot ? multiSuffix : `.${multiSuffix}`, singleSuffix: noDot ? split.pop() : `.${split.pop()}` }
    }
  }

  const suffix = noDot ? split.pop() : `.${split.pop()}`
  const name = split.join('.')
  return { name, suffix }
}
